module.exports = __webpack_public_path__ + "img/mind_skeleton_27.66cb6706.png";